import * as React from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import PopupManager, { type PopupId } from "./PopupManager";

type Props = {
    children: React.ReactNode;
    onHide?: () => void;
    icon: React.ReactNode;
    classes: Array<string>;
    id: PopupId;
    wobble: boolean;
};

type State = {
    dismissed: boolean;
    classes: Array<string>;
    timer: false | ReturnType<typeof setTimeout>;
};

export default class LocalPopup extends React.Component<Props, State> {
    public state: State = {
        dismissed: false,
        timer    : false,
        classes  : [ "entering" ],
    };

    public componentDidMount(): void {
        this.setState({
            timer: setTimeout(() => {
                this.setState({
                    classes: [],
                });
            }, 500),
        });
    }

    public componentWillUnmount(): void {
        if(this.state.timer !== false) {
            clearTimeout(this.state.timer);
        }
    }

    public handleDismiss = (): void => {
        PopupManager.remove(this.props.id);
    };

    public render(): React.ReactNode {
        let classes = this.props.classes;

        if(!classes) {
            classes = [];
        }

        classes = [
            "local-popup",
            ...classes,
            ...this.state.classes,
        ];

        if(this.props.wobble) {
            classes.push("wobble");
        }

        return (
            <div className={classes.join(" ")}>
                {typeof this.props.icon !== "undefined" && (
                    <div className="popup-icon">
                        {this.props.icon}
                    </div>
                )}
                <div className="popup-message">
                    {this.props.children}
                </div>
                <div className="popup-dismiss" onClick={this.handleDismiss}>
                    <FontAwesomeLight icon="times" />
                </div>
            </div>
        );
    }
}
